export const awsConfig = {
    region: 'us-west-2',
    userPoolId: 'us-west-2_trclva4D9',
    userPoolWebClientId: '4iquphenuast6a3rgn9qg7plh6',
    identityPoolId: 'us-west-2:7db75e8d-59ba-49ea-b5d1-52c1c36078f3',
    hostedUiPrefix: 'busmap-app',
};